import type { SVGProps } from 'react';
const SvgCloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    className="close-icon_svg__w-full close-icon_svg__h-full"
    viewBox="0 0 14 14"
    {...props}
  >
    <rect width={18.634} height={1.165} rx={0.582} transform="rotate(-44.999 15.905 6.588)" />
    <rect width={18.634} height={1.165} rx={0.582} transform="rotate(44.999 .412 .994)" />
  </svg>
);
export default SvgCloseIcon;
